import React from 'react';
const benefits = [{
  title: 'Tranquilidad ante lo cotidiano',
  desc: 'Saber exactamente qué hacer y dónde buscar cuando alguien en casa no se siente bien, sin depender de internet.'
}, {
  title: 'Autonomía y confianza',
  desc: 'Recuperar el control sobre el bienestar de tu familia usando soluciones simples, seguras y probadas por generaciones.'
}, {
  title: 'Organización que ahorra tiempo',
  desc: 'Dejar de buscar información dispersa. Todo está categorizado por síntoma para que encuentres la respuesta en segundos.'
}, {
  title: 'Bienestar familiar integral',
  desc: 'Crear un entorno más natural en casa con alternativas suaves y efectivas para grandes y pequeños.'
}];
export function Benefits() {
  return <section className="py-8 md:py-12 px-5 bg-cream-100 texture-paper" data-id="element-24">
      <div className="max-w-4xl mx-auto" data-id="element-25">
        <div className="text-center mb-8 md:mb-12 max-w-2xl mx-auto" data-id="element-26">
          <p className="text-xs uppercase tracking-[0.2em] text-olive-600 font-medium mb-4" data-id="element-27">
            Transformación real
          </p>
          <h2 className="font-serif font-medium text-3xl md:text-4xl text-ink-900 leading-tight" data-id="element-28">
            Lo que esta biblioteca{' '}
            <span className="italic text-olive-600" data-id="element-29">
              cambia en tu día a día
            </span>
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-4 md:gap-5" data-id="element-30">
          {benefits.map((b, idx) => <div key={idx} className="bg-cream-50 border border-cream-300 rounded-2xl p-6 md:p-8 shadow-sm" data-id="element-31">
              <div className="flex items-start gap-4 mb-3" data-id="element-32">
                <span className="font-serif text-olive-500 text-xl font-semibold opacity-50" data-id="element-33">
                  0{idx + 1}
                </span>
                <h3 className="font-serif font-medium text-xl text-ink-900 leading-tight flex-1" data-id="element-34">
                  {b.title}
                </h3>
              </div>
              <p className="text-base text-ink-700 leading-relaxed pl-9" data-id="element-35">
                {b.desc}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}